import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgBus = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M21 1H3a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2ZM3 3h18v16H3V3Z" />
      <path d="M8 19H4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1ZM20 19h-4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1ZM13.5 7a1 1 0 0 1 .117 1.993L13.5 9h-3a1 1 0 0 1-.117-1.993L10.5 7h3ZM6 16a1 1 0 0 1 .117 1.993L6 18H5a1 1 0 0 1-.117-1.993L5 16h1ZM14.5 16a1 1 0 0 1 .117 1.993L14.5 18h-5a1 1 0 0 1-.117-1.993L9.5 16h5ZM22 11.5a1 1 0 0 1 .117 1.993L22 13.5H2a1 1 0 0 1-.117-1.993L2 11.5h20ZM22 4a1 1 0 0 1 .117 1.993L22 6H2a1 1 0 0 1-.117-1.993L2 4h20ZM19 16a1 1 0 0 1 .117 1.993L19 18h-1a1 1 0 0 1-.117-1.993L18 16h1Z" />
      <path d="M2 2a1 1 0 0 1 .993.883L3 3v4a1 1 0 0 1-1.993.117L1 7V3a1 1 0 0 1 1-1ZM22 2a1 1 0 0 1 .993.883L23 3v4a1 1 0 0 1-1.993.117L21 7V3a1 1 0 0 1 1-1ZM2 9.5a1 1 0 0 1 .993.883L3 10.5v4a1 1 0 0 1-1.993.117L1 14.5v-4a1 1 0 0 1 1-1ZM22 9.5a1 1 0 0 1 .993.883L23 10.5v4a1 1 0 0 1-1.993.117L21 14.5v-4a1 1 0 0 1 1-1Z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgBus)
const Memo = memo(ForwardRef)
export default Memo
